import React from 'react';

import { SelectProps } from 'antd/lib';
import styled from 'styled-components';

import Select from 'components/lib/Select';

const StyledSelect = styled(Select)<{ $width: string }>`
  flex: ${({ $width }) => ($width === '100%' ? '1' : '0 0 auto')};
  min-width: 0;
  width: ${({ $width }) => $width};
  margin-right: ${({ $width }) => ($width === '100%' ? '0' : '30px')};
  &&&.ant-select {
    height: 36px;
  }

  &&& .ant-select-selector {
    border-radius: 0;
  }

  .ant-select-selection-item {
    font-size: 14px;
  }
`;

type ShopRequestStyledSelectProps = SelectProps & {
  dataTestId?: string;
  width: string;
};

const ShopRequestStyledSelect = ({ width, ...props }: ShopRequestStyledSelectProps) => {
  return <StyledSelect $width={width} {...props} />;
};

export default ShopRequestStyledSelect;
